import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import {MaterialModule} from "../../material/material.module";
import { BankingOwnerInformationComponent } from './banking-owner-information/banking-owner-information.component';
import { HeaderBannerComponent } from '../../shared/header-banner/header-banner.component';



@NgModule({
  declarations: [
    BankingOwnerInformationComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
  ]
})
export class BankOwnerInformationModule { }
